/**
 * Auth Layout Component
 * Layout for authentication pages
 */

import { Outlet, Link } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen">
      {/* Left side - Branding */}
      <div className="hidden w-1/2 bg-primary-600 lg:flex lg:flex-col lg:justify-between lg:p-12">
        <div>
          <Link to="/" className="flex items-center space-x-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-white text-primary-600 font-bold text-lg">
              S
            </div>
            <span className="text-2xl font-bold text-white">SMB App</span>
          </Link>
        </div>

        <div className="space-y-6">
          <h1 className="text-4xl font-bold text-white">
            Manage your business with confidence
          </h1>
          <p className="text-lg text-primary-100">
            Streamline your operations with our all-in-one business management
            platform. Handle customers, invoices, payments, and more.
          </p>
          <div className="flex space-x-8">
            <div>
              <p className="text-3xl font-bold text-white">10k+</p>
              <p className="text-sm text-primary-200">Businesses</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-white">$1B+</p>
              <p className="text-sm text-primary-200">Processed</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-white">99.9%</p>
              <p className="text-sm text-primary-200">Uptime</p>
            </div>
          </div>
        </div>

        <p className="text-sm text-primary-200">
          &copy; {new Date().getFullYear()} SMB App. All rights reserved.
        </p>
      </div>

      {/* Right side - Auth form */}
      <div className="flex w-full items-center justify-center px-4 py-12 lg:w-1/2">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="mb-8 text-center lg:hidden">
            <Link to="/" className="inline-flex items-center space-x-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-600 text-white font-bold text-lg">
                S
              </div>
              <span className="text-2xl font-bold text-gray-900">SMB App</span>
            </Link>
          </div>

          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
